import { render } from "./AddCentralePage.vue?vue&type=template&id=63b718c2"
import script from "./AddCentralePage.vue?vue&type=script&lang=js"
export * from "./AddCentralePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__